/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 *
 * Presentation layout for the Explore filter sidebar — one entry per filter
 * group describing HOW it renders (section type, subtitle, subgroups). This is
 * the single source of truth for filter-group presentation, consumed by the
 * config-driven <UniverseFilter/>.
 *
 * WHICH groups a product shows is decided separately by the product tags in
 * common/metadata/FilterConfig.js (GROUP_PRODUCT_TAGS); this file only describes
 * how each group looks once it is shown.
 */

// 'multi'  → MultiSubgroupFilterSection (group with nested subgroup panels)
// 'single' → FilterSection (flat group)
export const GROUP_LAYOUT = [
    {
        key: 'TRADES',
        section: 'single',
        title: 'TRADES',
        subTitle: 'What kind of work this contractor specializes in',
        defaultOpen: true,
    },
    {
        key: 'TERRITORY',
        section: 'multi',
        title: 'TERRITORY',
        subTitle: 'Where the contractor operates and is authorized to work',
        defaultMainOpen: true,
        subGroups: [
            { key: 'LOCATION', label: 'LOCATION' },
            { key: 'AUTHORIZATION_&_ACTIVITY', label: 'AUTHORIZATION & ACTIVITY' },
        ],
    },
    {
        key: 'SERVICES',
        section: 'multi',
        title: 'SERVICES',
        subTitle: 'What services they offer and how they deliver work',
        defaultMainOpen: true,
        subGroups: [
            { key: 'CAPABILITIES', label: 'CAPABILITIES' },
            { key: 'BRAND_RELATIONSHIPS', label: 'BRAND RELATIONSHIPS' },
        ],
    },
    {
        key: 'PROFILE',
        section: 'multi',
        title: 'PROFILE',
        subTitle: 'Who this contractor is...',
        subGroups: [
            { key: 'OVERVIEW', label: 'OVERVIEW', defaultOpen: true },
            { key: 'REACHABILITY', label: 'REACHABILITY' },
            { key: 'BASICS', label: 'BASICS' },
            { key: 'AFFILIATIONS', label: 'AFFILIATIONS' },
            { key: 'PRESENCE', label: 'PRESENCE' },
            { key: 'IDENTIFIERS', label: 'IDENTIFIERS' },
        ],
    },
    {
        key: 'SCALE',
        section: 'multi',
        title: 'SCALE',
        subTitle: 'How large and established the contractor is',
        subGroups: [
            { key: 'SIZE_&_MATURITY', label: 'SIZE & MATURITY' },
            { key: 'ORGANIZATIONAL_FOOTPRINT', label: 'ORGANIZATIONAL FOOTPRINT' },
        ],
    },
    {
        key: 'SIGNALS',
        section: 'single',
        title: 'SIGNALS',
        subTitle: 'Are they active right now? Indicators of intent and growth.',
    },
    {
        key: 'COMPLIANCE',
        section: 'single',
        title: 'COMPLIANCE',
        subTitle: 'Whether the contractor meets legal and regulatory requirements',
    },
    {
        key: 'CONTACTS',
        section: 'single',
        title: 'CONTACTS',
        subTitle: 'Who to contact and their role in the business',
    },
    {
        key: 'DISCOVER',
        section: 'single',
        title: 'DISCOVER',
        subTitle: 'Search across reviews, websites, licenses, permits, and projects.',
    },
    {
        key: 'SOURCES',
        section: 'single',
        title: 'SOURCES',
        subTitle: 'Where the data comes from and how recent it is',
    },
    {
        key: 'LISTS',
        section: 'single',
        title: 'LISTS',
        subTitle: 'Use your saved lists and searches to include or exclude contractors from your results.',
    },
];

// Explore uses universe keys ('CONTRACTOR' | 'BUSINESS'); subscriptions and
// filter tags use product keys. Map between them here.
const UNIVERSE_TO_PRODUCT = {
    CONTRACTOR: 'contractor_universe',
    BUSINESS: 'business_universe',
};

export const universeKeyToProductKey = (universeKey) => UNIVERSE_TO_PRODUCT[universeKey];
